import moment from 'moment/moment';
import { ethers } from 'ethers';
import { getAddress } from './get-address';
import TokenDistributor from '../abi/TokenDistributor.json';
import { getTokens } from './get-tokens';

const timestampToTime = (timestamp) => {
  timestamp = Number(timestamp);
  var d = Math.floor(timestamp / (3600 * 24));
  var h = Math.floor((timestamp % (3600 * 24)) / 3600);
  var dDisplay = d > 0 ? d + (d === 1 ? ' Day ' : ' Days ') : '';
  var hDisplay = h > 0 ? h + (h === 1 ? ' Hour ' : ' Hours ') : '';
  return dDisplay || hDisplay || '0 Hours';
};

export const getBalance = async (_address) => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const { chainId } = await provider.getNetwork();
    const addresses = getAddress(chainId);
    if (!addresses) {
      return { success: false, message: 'Wrong network!' };
    }

    const signer = provider.getSigner();
    const hopeDistributor = new ethers.Contract(
      addresses.hope_distributor,
      TokenDistributor.abi,
      signer
    );

    const decimals = 18;

    const userBalances = await hopeDistributor.userBalances(_address);
    const totalBalance = parseFloat(userBalances.totalBalance.toString()) / 10 ** decimals;
    const totalDistributedAmount = parseFloat(userBalances.totalDistributedAmount.toString()) / 10 ** decimals;

    const vestedAmount = await hopeDistributor.getVestedAmount(_address);
    const formattedVestedAmount = parseFloat(vestedAmount.toString()) / 10 ** decimals;

    const swapHistory = await hopeDistributor.getSwapHistory(_address);


    const formattedSwapHistory = swapHistory.filter(swap => swap.isActive || (swap.isActive == false && swap.hopeInitialBalance == swap.hopeDistributed)).map(swap => {
      const tokens = getTokens(swap.chain.toString());
      const token = tokens.find(t => t.address.toLowerCase() === swap.variant.toLowerCase()) || {};
      const obj = {
        isActive: swap.isActive,
        chain: swap.chain,
        variant: swap.variant,
        variantAmount: parseFloat(swap.variantAmount.toString()) / 10 ** (token.decimals),
        hopeInitialBalance: parseFloat(swap.hopeInitialBalance.toString()) / 10 ** decimals,
        hopeBalance: parseFloat(swap.hopeBalance.toString()) / 10 ** decimals,
        distributedAmount: parseFloat(swap.hopeDistributed.toString()) / 10 ** decimals,
        vestingSchedule: timestampToTime(swap.vestingSchedule),
        vestingStartTime: swap.vestingStartTime.toString(),
        lastClaimTime: swap.lastClaimTime.toString(),
        token,
      }
       return obj
    });

    return {
      success: true,
      balance: totalBalance.toFixed(5),
      vestedAmount: formattedVestedAmount.toFixed(5),
      claimedAmount: totalDistributedAmount.toFixed(5),
      swapHistory: formattedSwapHistory,
    };
  } catch (e) {
    return {
      success: false,
      message: e.message,
    };
  }
};
